import { useQuery } from '@apollo/client';
import { gql, PaymentStatus } from '@eti/schema-types';

export const PAYMENT_STATUS = gql(/* GraphQL */ `
  query getPaymentStatus($paymentTransactionId: Long!) {
    paymentStatus(paymentTransactionId: $paymentTransactionId) {
      status
    }
  }
`);

const usePaymentStatus = (paymentTransactionId?: number | string | null, pollInterval = 5000) => {
  const variables = {
    paymentTransactionId: Number(paymentTransactionId),
  };
  const { data, loading, stopPolling, error } = useQuery(PAYMENT_STATUS, {
    pollInterval,
    variables,
    skip: !paymentTransactionId,
  });

  const status = data?.paymentStatus?.status;
  const hasError = Boolean(error) || status === PaymentStatus.Error;

  if (status === PaymentStatus.Completed || hasError) {
    stopPolling();
  }

  return {
    error,
    hasError,
    loading,
    status,
    stopPolling,
  };
};

export default usePaymentStatus;
